/**
 * Configuration for authentication-related cookies
 */

export const AUTH_COOKIE_CONFIG = {
  POST_AUTH_NEXT: {
    name: 'post_auth_next',
    maxAge: 300, // 5 minutes
    path: '/',
    sameSite: 'Lax' as const,
    secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
  },
} as const;

/**
 * Helper to create cookie string for post_auth_next
 */
export function createPostAuthNextCookie(value: string): string {
  const config = AUTH_COOKIE_CONFIG.POST_AUTH_NEXT;
  const attrs = [`path=${config.path}`, `SameSite=${config.sameSite}`, `Max-Age=${config.maxAge}`];

  if (config.secure) {
    attrs.push('Secure');
  }

  return `${config.name}=${encodeURIComponent(value)}; ${attrs.join('; ')}`;
}

/**
 * Helper to create cookie deletion string for post_auth_next
 */
export function deletePostAuthNextCookie(): string {
  const config = AUTH_COOKIE_CONFIG.POST_AUTH_NEXT;
  return `${config.name}=; path=${config.path}; Max-Age=0; SameSite=${config.sameSite}`;
}
